import { render, staticRenderFns } from "./openAcct.vue?vue&type=template&id=55d33a48"
import script from "./openAcct.vue?vue&type=script&lang=js"
export * from "./openAcct.vue?vue&type=script&lang=js"
import style0 from "./openAcct.vue?vue&type=style&index=0&id=55d33a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports